import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
    standalone: true,
    selector: 'ms-sgp-plus-badge',
    template: ` <div class="theme-bet-builder-plus sgp-badge ui-icon-size-lg"></div> `,
    styleUrl: './sgp-plus-badge.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SGPPlusBadgeComponent {
    @HostBinding('class.large') get large(): boolean {
        return this.size() === 'large';
    }

    size = input<'large'>();
}
